"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const icon_1 = __importDefault(require("../icon/icon"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const constants_1 = require("../../constants/constants");
const defaultProps = {
    withMinHeight: true,
    expandedOnFirstView: false,
};
const ExpandableBox = ({ baseComponent, expandedComponent, title, expandedOnFirstView, withMinHeight, eventName, }) => {
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_1);
    const [expanded, setExpanded] = react_1.useState(expandedOnFirstView);
    const content = expanded ? expandedComponent : baseComponent;
    const minHeightStyle = isDesktop ? styles_1.default.minHeight : { minHeight: 340 };
    return (react_1.default.createElement(react_native_1.View, { style: withMinHeight ? [styles_1.default.boxStyles, minHeightStyle] : styles_1.default.boxStyles },
        react_1.default.createElement(pressable_1.default, { onPress: () => setExpanded(!expanded), style: styles_1.default.flexDirectionRow, eventName: eventName },
            typeof title === 'string' ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.flexOne] },
                react_1.default.createElement(boxTitle_1.default, { title: title }))) : (title),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                react_1.default.createElement(pressable_1.default, { onPress: () => setExpanded(!expanded), eventName: eventName }, expanded ? react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faChevronUp }) : react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faChevronDown })))),
        content));
};
ExpandableBox.defaultProps = defaultProps;
exports.default = ExpandableBox;
